import { action } from 'typesafe-actions';
import { ISolicitacaoRetorno, SolicitacaoRetornoTypes } from './types';

export const loadSolicitacaoRequest = ( 
    cddAtivo: number | undefined, solicitacoes: {} | undefined) => action(
      SolicitacaoRetornoTypes.LOAD_SOLICITACAO_REQUEST, { cddAtivo,
      solicitacoes});

export const loadSocilitacaoSuccess = (data: ISolicitacaoRetorno[]) => 
  action(SolicitacaoRetornoTypes.LOAD_SOLICITACAO_SUCCESS, { data });

export const loadSolicitacaoFailure = () => action(SolicitacaoRetornoTypes.LOAD_SOLICITACAO_FAILURE);

export const radioSelect = (radio: number) => action(SolicitacaoRetornoTypes.RADIO_SELECT, { radio });

